import React from 'react';
import { Component } from './item-types';
import Link from 'next/link';
import { Typography } from '@mui/material';

export default function ItemComponents({
  components,
}: {
  components: Component[];
}) {
  return (
    <div
      style={{
        display: 'grid',
        gap: '2px',
        gridTemplateColumns: 'auto auto',
      }}
    >
      {components.map((comp) => (
        <React.Fragment key={comp.inv_mast_uid}>
          <Link href={`/item?itemId=${comp.item_id}`}>
            <Typography>{comp.item_id}</Typography>
          </Link>
          <Typography>{comp.extended_desc}</Typography>
        </React.Fragment>
      ))}
    </div>
  );
}
